import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
interface Response {
  error_code: number;
  error_msg: string;
  data?: any;
}
interface ChatList {
  page: number;
  page_size: number;
  search_words?: string;
  unfinished?: number;
}
interface ChatDetail {
  operator_id?: number;
}
interface QuickMessageList {
  quick_message_group_ids?: Array<number>;
  create_user_ids?: Array<number>;
  page?: number;
  page_size?: number;
  active?: number;
}
interface SendMessage {
  type: string;
  content: string;
  operator_id?: number;
}
interface Translate {
  to: string;
  sentences: Array<string>;
}
interface UpdateChat {
  operator_id?: number;
  device?: string;
  note?: string;
  is_top?: number;
  is_unfinished?: number;
}
interface MessageList {
  operator_id?: number;
  msgid?: string;
  timestamp?: number;
  page_size: number;
}
interface SendVisitInfo {
  name: string;
  mobile?: string;
  email?: string;
  address?: string;
}
interface ReadChat {
  operator_id: number;
}
interface TransferService {
  operator_id: string;
  transfer_service_id: number;
}
interface EndConversion extends ReadChat {}

const CHAT_LIST_API = '/api/customer_service/chat/list';
const CHAT_DETAIL_API = '/api/customer_service/chat/detail';
const MESSAGE_LIST_API = '/api/customer_service/chat/message';
const QUICK_MESSAGE_GROUP_LIST_API = '/api/quick_message/group_list';
const QUICK_MESSAGE_LIST_API = '/api/quick_message/list';
const SEND_MESSAGE_API = '/api/customer_service/chat/send';
const TRANSLATE_API = '/api/chat/translate';
const UPDATE_CHAT_API = '/api/customer_service/chat/update';
const UPLOAD_API = '/api/upload/image';
const CUSTOMER_STATUS_API = '/api/customer_service/chat/status';
const UPDATE_STATUS_API = '/api/customer_service/chat/update_status';
const CONTACT_API = '/api/customer_service/chat/concat';
const READ_API = '/api/customer_service/chat/read';
const SEND_VISIT_INFO_API = '/api/customer_service/chat/send_concat';
const SERVICE_LIST_API = '/api/customer_service/chat/service_list';
const TRANSFER_SERVICE_API = '/api/customer_service/chat/transfer';
const END_CONVERSION_API = '/api/customer_service/chat/end_conversion';

@Injectable({
  providedIn: 'root'
})
export class HttpServerService {

  constructor(private http: HttpClient) { }

  fetchChatList(params: ChatList) {
    const query = new HttpParams()
      .append('page', `${params.page}`)
      .append('page_size', `${params.page_size}`)
      .append('search_words', `${params.search_words}`)
      .append('unfinished', `${params.unfinished}`);

    return this.http.get(CHAT_LIST_API, { params: query }) as Observable<Response>;
  }

  fetchChatDetail(params?: ChatDetail) {
    const query = new HttpParams().append('operator_id', `${params.operator_id}`);

    return this.http.get(CHAT_DETAIL_API, { params: query }) as Observable<Response>;
  }

  fetchMessageList(params: MessageList) {
    const query = new HttpParams()
      .append('operator_id', `${params.operator_id}`)
      .append('msgid', `${params.msgid}`)
      .append('timestamp', `${params.timestamp}`)
      .append('page_size', `${params.page_size}`);

    return this.http.get(MESSAGE_LIST_API, { params: query }) as Observable<Response>;
  }

  fetchQuickMessageGroupList() {
    return this.http.get(QUICK_MESSAGE_GROUP_LIST_API) as Observable<Response>;
  }

  fetchQuickMessageList(params: QuickMessageList) {
    const query = new HttpParams()
      .append('page', `${params.page}`)
      .append('page_size', `${params.page_size}`)
      .append('quick_message_group_ids', `${params.quick_message_group_ids}`)
      .append('create_user_ids', `${params.create_user_ids}`)
      .append('active', `${params.active}`)
      .append('only_self', '1')
    return this.http.get(QUICK_MESSAGE_LIST_API, { params: query }) as Observable<Response>;
  }

  fetchServiceList () {
    return this.http.get(SERVICE_LIST_API) as Observable<Response>;
  }

  transferService (params: TransferService) {
    return this.http.post(TRANSFER_SERVICE_API, params) as Observable<Response>;
  }

  endConversion (params: EndConversion) {
    return this.http.post(END_CONVERSION_API, params) as Observable<Response>;
  }

  sendMessage(params: SendMessage) {
    return this.http.post(SEND_MESSAGE_API, params) as Observable<Response>;
  }

  translate(params: Translate) {
    return this.http.post(TRANSLATE_API, params) as Observable<Response>;
  }

  updateChat(params: UpdateChat) {
    return this.http.post(UPDATE_CHAT_API, params) as Observable<Response>;
  }

  upload(params: FormData) {
    return this.http.post(UPLOAD_API, params) as Observable<Response>;
  }

  fetchCustomerStatus() {
    return this.http.get(CUSTOMER_STATUS_API) as Observable<Response>;
  }

  updateCustomerStatus() {
    return this.http.post(UPDATE_STATUS_API, null) as Observable<Response>;
  }

  contact(params) {
    return this.http.post(CONTACT_API, params) as Observable<Response>;
  }

  read(params?: ReadChat) {
    return this.http.post(READ_API, params) as Observable<Response>;
  }

  reportVisitInfo(params: SendVisitInfo) {
    return this.http.post(SEND_VISIT_INFO_API, params) as Observable<Response>;
  }
}
